import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import useNotificationContext from 'hooks/useNotificationContext';

function NotificationSnackbar() {
    const { open, message, severity, autoHideDuration, hideNotification } = useNotificationContext();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        hideNotification();
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}

export default NotificationSnackbar;
